<template>
  <div
    :class="efClass"
    class="popArea whiteBg"
  >
    <div
      class="defaultSect2 culturePop"
      :class="readyAction ? 'ready-action' : ''"
    >
      <div class="cultureList">
        <ul>
          <li
            class="step"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="listFl cultImgarea">
              <div class="cultureImg">
                <span class="moveTxt"><marquee-text :duration="6">&nbsp;Relax Relax</marquee-text></span>
                <img
                  src="@/assets/images/culture_img1.jpg"
                  alt=""
                >
              </div>
            </div>
            <div class="listFr cultureText">
              <span class="emojiCult">
                <img
                  src="@/assets/images/emoji_beach.png"
                  alt=""
                >
              </span>
              <div class="CultTitle mo-typo01">
                <span>{{ $t('culture.data[0].title[0]') }}</span><br>
                <span class="familyMono yellow">
                  {{ $t('culture.data[0].title[1]') }}
                </span>
              </div>
              <p class="CultSubT">
                {{ $t('culture.data[0].content') }}
              </p>
            </div>
          </li>
          <li
            class="step"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="listFl cultureText">
              <span class="emojiCult">
                <img
                  src="@/assets/images/emoji_firecracker.png"
                  alt=""
                >
              </span>
              <div class="CultTitle mo-typo01">
                <span>{{ $t('culture.data[1].title[0]') }}</span><br>
                <span class="yellow">
                  {{ $t('culture.data[1].title[1]') }}
                </span>
              </div>
              <p class="CultSubT">
                {{ $t('culture.data[1].content') }}
              </p>
            </div>
            <div class="listFr cultImgarea">
              <div class="cultureImg">
                <span class="moveTxt"><marquee-text :duration="7">&nbsp;Welcome Welcome</marquee-text></span>
                <img
                  src="@/assets/images/culture_img2.jpg"
                  alt=""
                >
              </div>
            </div>
          </li>
          <li
            class="step"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="listFl cultImgarea">
              <div class="cultureImg">
                <span class="moveTxt"><marquee-text :duration="5">&nbsp;Thank you</marquee-text></span>
                <img
                  src="@/assets/images/culture_img3.jpg"
                  alt=""
                >
              </div>
            </div>
            <div class="listFr cultureText">
              <span class="emojiCult">
                <img
                  src="@/assets/images/emoji_gift.png"
                  alt=""
                >
              </span>
              <div class="CultTitle mo-typo01">
                <span>{{ $t('culture.data[3].title[0]') }}</span><br>
                <span class="yellow">
                  {{ $t('culture.data[3].title[1]') }}
                </span>
              </div>
              <p class="CultSubT">
                {{ $t('culture.data[3].content') }}
              </p>
            </div>
          </li>
          <li
            class="step"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="listFl cultureText">
              <span class="emojiCult">
                <img
                  src="@/assets/images/emoji_certificate.png"
                  alt=""
                >
              </span>
              <div class="CultTitle mo-typo01">
                <span>{{ $t('culture.data[4].title[0]') }}</span><br>
                <span class="yellow">
                  {{ $t('culture.data[4].title[1]') }}
                </span>
              </div>
              <p class="CultSubT">
                {{ $t('culture.data[4].content') }}
              </p>
            </div>
            <div class="listFr cultImgarea">
              <div class="cultureImg">
                <span class="moveTxt"><marquee-text :duration="8">&nbsp;Specialist Specialist</marquee-text></span>
                <img
                  src="@/assets/images/culture_img4.jpg"
                  alt=""
                >
              </div>
            </div>
          </li>
          <li
            class="step"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="listFl cultImgarea">
              <div class="cultureImg">
                <span class="moveTxt"><marquee-text :duration="8">&nbsp;Membership Membership</marquee-text></span>
                <img
                  src="@/assets/images/culture_img5.jpg"
                  alt=""
                >
              </div>
            </div>
            <div class="listFr cultureText">
              <span class="emojiCult">
                <img
                  src="@/assets/images/emoji_handshake.png"
                  alt=""
                >
              </span>
              <div class="CultTitle mo-typo01">
                <span>{{ $t('culture.data[5].title[0]') }}</span><br>
                <span class="yellow">
                  {{ $t('culture.data[5].title[1]') }}
                </span>
              </div>
              <p class="CultSubT">
                {{ $t('culture.data[5].content') }}
              </p>
            </div>
          </li>
          <li
            class="step"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="listFl cultureText">
              <span class="emojiCult">
                <img
                  src="@/assets/images/emoji_massage.png"
                  alt=""
                >
              </span>
              <div class="CultTitle mo-typo01">
                <span>{{ $t('culture.data[6].title[0]') }}</span><br>
                <span class="yellow">
                  {{ $t('culture.data[6].title[1]') }}
                </span>
              </div>
              <p class="CultSubT">
                {{ $t('culture.data[6].content') }}
              </p>
            </div>
            <div class="listFr cultImgarea">
              <div class="cultureImg">
                <span class="moveTxt"><marquee-text :duration="5.4">&nbsp;Health keeper</marquee-text></span>
                <img
                  src="@/assets/images/culture_img6.jpg"
                  alt=""
                >
              </div>
            </div>
          </li>
          <li
            class="step"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="listFl cultImgarea">
              <div class="cultureImg">
                <span class="moveTxt"><marquee-text :duration="5">&nbsp;Pulip Cafe</marquee-text></span>
                <img
                  src="@/assets/images/culture_img7.jpg"
                  alt=""
                >
              </div>
            </div>
            <div class="listFr cultureText">
              <span class="emojiCult">
                <img
                  src="@/assets/images/emoji_coffee.png"
                  alt=""
                >
              </span>
              <div class="CultTitle mo-typo01">
                <span>{{ $t('culture.data[7].title[0]') }}</span><br>
                <span class="yellow">
                  {{ $t('culture.data[7].title[1]') }}
                </span>
              </div>
              <p class="CultSubT">
                {{ $t('culture.data[7].content') }}
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MarqueeText from 'vue-marquee-text-component'
import common from '@/shared/mixin/common.js'
export default {
  mixins: [common],
  name: 'CulturePop',
  data () {
    return {
      efClass: '',
      readyAction: false
    }
  },
  components: {
    MarqueeText
  },
  computed: {
    ...mapState('common', {
      culturePop: state => state.culturePop
    })
  },
  watch: {
    culturePop (newValue) {
      if (newValue) {
        this.efClass = 'active'
      } else {
        this.efClass = 'leave'
        setTimeout(() => {
          this.efClass = ''
        }, 600)
      }
    }
  },
  methods: {
  },
  mounted () {
    this.efClass = this.culturePop ? 'active' : ''
    this.readyAction = true
  }
}
</script>
